import * as React from 'react';
import moment from 'moment';

import SelectStorySnippetsGroupedView from '../select-story-snippets-grouped-view/SelectStorySnippetsGroupedView';
import SelectStorySnippetsVideoPlayer from '../select-story-snippets-video-player/SelectStorySnippetsVideoPlayer';

import {
  findElementInGroups
} from 'modules/select-story-snippets/utils/general';

import { DISPLAY_DATE_FORMAT } from 'utils/date';
import { __t, applyTranslations } from 'utils/language';

import './select-story-snippets-preview-grid.scss';

applyTranslations(require('./select-story-snippets-preview-grid.i18n.json'));

import { GroupedByDate, StorySnippet } from 'modules/select-story-snippets/types';

interface Props {
  snippets: GroupedByDate<StorySnippet>,
  selectedSnippets: Array<string>,
  previewSnippetCode: string,
  onToggleSnippet: (code: string) => void,
  onRequestSnippetPreview: (code: string) => void
}

const SelectStorySnippetsPreviewGrid = ({
  snippets,
  selectedSnippets,
  previewSnippetCode,
  onToggleSnippet,
  onRequestSnippetPreview
}: Props): null | JSX.Element => {
  const snippet = findElementInGroups(snippets, previewSnippetCode);

  if (snippet === null) {
    return null;
  }

  return (
    <div className="select-story-snippets-preview-grid">
      <SelectStorySnippetsVideoPlayer
        snippets={snippets}
        previewSnippetCode={previewSnippetCode}
        onRequestSnippetPreview={onRequestSnippetPreview}
      />
      <div className="select-story-snippets-preview-grid__file-info">
        {snippet ? (
          __t('select_story_snippets_preview_grid.uploaded', {
            date: moment(snippet.takenAt).format(DISPLAY_DATE_FORMAT)
          })
        ) : null}
      </div>
      <div className="select-story-snippets-preview-grid__snippets">
        <SelectStorySnippetsGroupedView
          snippets={snippets}
          selectedSnippets={selectedSnippets}
          previewSnippetCode={previewSnippetCode}
          onToggleSnippet={onToggleSnippet}
          onRequestSnippetPreview={onRequestSnippetPreview}
        />
      </div>
    </div>
  );
};

export default SelectStorySnippetsPreviewGrid;
